export const downloadMediasFrame = (url: string) => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';

  iframe.src = url;
  iframe.onload = () => document.body.removeChild(iframe);

  document.body.appendChild(iframe);
};
